import { useEffect } from "react";
import { useShortcut } from "./useShortcut.ts";

export function useGlobalShortcut(descriptor: string, onTrigger: () => void) {
    const { matchesEvent } = useShortcut(descriptor);

    useEffect(() => {
        const controller = new AbortController();

        document.addEventListener(
            "keydown",
            event => {
                if (!matchesEvent(event)) {
                    return;
                }

                event.preventDefault();
                onTrigger();
            },
            { signal: controller.signal }
        );

        return () => controller.abort();
    }, [matchesEvent, onTrigger]);
}
